import { render, staticRenderFns } from "./TweetBox.vue?vue&type=template&id=39664b2d"
import script from "./TweetBox.vue?vue&type=script&lang=js"
export * from "./TweetBox.vue?vue&type=script&lang=js"
import style0 from "./TweetBox.vue?vue&type=style&index=0&id=39664b2d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports